export class DashboardVejledningModel {
    brugerId: string;
    forloebId: string;

    static Build(responseModel: DashboardVejledningResponseModel): DashboardVejledningModel {
        let model = new DashboardVejledningModel();
        model.brugerId = responseModel.brugerId;
        model.forloebId = responseModel.forloebId;
        return model;
    }
}

export type DashboardVejledningResponseModel = {
    brugerId: string;
    forloebId: string;
}
